/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#create-folder-dialog-form[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{text-align:left}#create-folder-dialog-form[_ngcontent-%COMP%]   .mat-error[_ngcontent-%COMP%]{margin-bottom:.83em}#create-folder-dialog-form[_ngcontent-%COMP%]   .full-width-input[_ngcontent-%COMP%]{display:block}#create-folder-dialog-form[_ngcontent-%COMP%]   #create-folder-button[_ngcontent-%COMP%]{width:100%;margin:10px 0}"];
export { styles as styles };
